import useUserContext from "../../../../hooks/useUserContext"

const getIsUserIsBanned = (userData) => {
  if (userData?.user && typeof userData?.user  === 'object') {
    return !userData.user?.active
  }

  return !userData?.active
}

export const useIsBanned = () => {
  const { userData } = useUserContext()
  return getIsUserIsBanned(userData)
}